import React from 'react';
import ButtonCancelForm from '../../../components/buttons/ButtonCancelForm';
import ButtonSaveForm from '../../../components/buttons/ButtonSaveForm';
import { GroupDataForm } from '../../../app/models/Group';
import GroupForm from './forms/GroupForm';
import GroupNotificationForm from './forms/GroupNotificationForm';
import { Action, ActionCategory, GroupActionDataForm } from '../../../app/models/Action';

interface Props {
    fetching?: boolean;
    action: () => void;
    cancel: () => void;
    errorFields?: any;
    categories: ActionCategory[];
    groupActions: Action[]
    setGroupActions: (action: Action[]) => void;
    setGroupActionDataForm:(groupActionDataForm: GroupActionDataForm) => void;
}

const GroupNotificationFormContainer = ({
    fetching,
    action,
    cancel,
    categories,
    groupActions,
    setGroupActions,
    setGroupActionDataForm,
    errorFields = null
}: Props) => {
    return (
        <>
            <div className="row">
                <div className="col-12">
                    <GroupNotificationForm
                        errorFields={errorFields}
                        categories={categories}
                        groupActions={groupActions}
                        setGroupActions={setGroupActions}
                        setGroupActionDataForm={setGroupActionDataForm}     
                    />
                </div>
            </div>
            <hr />
            <div className="row justify-content-end">
                <div className="col-auto">
                    <ButtonCancelForm callbackCancel={cancel} locked={fetching} />
                </div>
                <div className="col-auto">
                    <ButtonSaveForm callbackSave={action} locked={fetching} />
                </div>
            </div>
        </>
    );
};

export default GroupNotificationFormContainer;
